import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import '../styles/pages/end.scss';
import { QUERY_VOX_URL } from '../utils/graph-api';
import { tspan } from '../utils/i18n';
import {TitleText} from './start';
import styled from 'styled-components';
import CloseButton from "../components/buttons/close";


const PrivacyDescription= styled.p`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 17px;
  display: flex;
  align-items: center;
  text-align: justify;
  color: #858C9A;
  width: 90%;
`;

const PrivacyLink = styled.div`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 17px;
  display: flex;
  align-items: center;
  text-align: justify;
  color: #858C9A;
  width: 90%;
  display: inline;
  span{
    text-decoration : none!important;
  }
  a{
  color: #858C9A;
  }
`;
export const CloseButtonContainer = styled.div`
  height: 2.5rem !important;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 4px;
  width: 90% !important;
  margin: 0 auto 0.25rem auto !important;
  cursor: pointer;
  z-index: 1;
  &:hover {
      background: #2e394f;
      color: white;
    }
  &:hover #timesIcon{
  color: white;
  }  
`;
const MainContainer = styled.div`
  animation: inAnimation 250ms ease-out;
  @keyframes inAnimation {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  100% {
    transform: scale(1);
  }
}

`;
class Privacy extends Component {

    async componentDidMount() {
        const { id, client } = this.props;
        // Get the last uploaded vox
        const { data } = await client.query({
            query: QUERY_VOX_URL,
            variables: { id }
        });
        const { recordingUrl } = data.getVox;

        this.setState({ voxURL: recordingUrl });
    }
    proceed = ()=> {
        const {  onSwitch, activePage } = this.props;
        const { common } = this.props.settings;
        onSwitch(activePage);
    }

    render() {
        // const { voxURL } = this.state;
        const { common } = this.props.settings;

        return (
            <>
                <MainContainer className="content">
                    <div className="plugin-header">
                        {/* Title for final page */}
                        <div
                            className="title"
                            style={{
                                // fontFamily: common.fontFamily,
                                // color: common.fontColor,
                            }}
                        >
                            <TitleText> {tspan('privacyTitle')}</TitleText>
                        </div>
                    </div>
                    {common.isPublicHosted ? (
                        <>
                            <PrivacyDescription
                                className="thanks-sub"
                                style={{
                                    // fontFamily: common.fontFamily,
                                    // color: common.fontColor,
                                    marginTop: '1.7rem',}}>
                                {tspan('publicHostedprivacyData', { break: <br /> })}
                            </PrivacyDescription>
                            <PrivacyDescription className="thanks-sub">
                                {tspan('publicHostedprivacyData2', { break: <br /> })}
                            </PrivacyDescription>
                        </>
                    ) : (
                        <PrivacyDescription
                            className="thanks-sub"
                            style={{
                                // fontFamily: common.fontFamily,
                                // color: common.fontColor,
                                marginTop: '1.7rem',
                            }}
                        >
                            {tspan('privacyDataUsage', { break: <br /> })}
                        </PrivacyDescription>
                    )}
                    <PrivacyLink>
                    <span>Please&nbsp;</span>
                    <a href={common.isPublicHosted ? "https://blessourheroes.webflow.io/legal/privacy-policy" :
                        "https://www.telbee.io/privacy/"} rel="noopener noreferrer" target="_blank" >
                         click here to read {common.isPublicHosted ? "#BlessOurHeroes" : "telbee’s"} full privacy policy
                    </a>
                    </PrivacyLink>
                </MainContainer>
                <CloseButtonContainer
                    className="buttons"  onClick={()=> this.proceed()}>
                    <CloseButton size="2x"/>
                </CloseButtonContainer>

            </>
        );
    }
}

export default withApollo(Privacy);
